/* eslint-disable import/prefer-default-export */
/* eslint-disable no-unused-vars */

/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */
import { parseJSON } from 'date-fns';

import { BaseSocialFeedAdapter } from '../BaseSocialFeedAdapter/BaseSocialFeedAdapter';

export class CuratorSocialFeedAdapter extends BaseSocialFeedAdapter {
    constructor(args) {
        super();

        if (!args) {
            throw new Error(
                `args is required when instantiating a new CuratorSocialFeedAdapter object`
            );
        }

        ['curatorUrl', 'apiKey', 'feedId'].forEach((name) => {
            if (!args[name]) {
                throw new Error(
                    `${name} property is required when instantiating a new CuratorSocialFeedAdapter object`
                );
            }
        });

        this.curatorUrl = args.curatorUrl;
        this.apiKey = args.apiKey;
        this.feedId = args.feedId;
    }

    /**
     * Get feed data.
     * @param {object} args The feed request object.
     * @returns void
     */
    getFeedData({ feedId, maxItems }) {
        const url = `${this.curatorUrl}/feeds/${this.feedId}/posts?api_key=${
            this.apiKey
        }&limit=${maxItems || 25}`;

        const promise = fetch(url)
            .then((response) => {
                return response.json();
            })
            .then((result) => {
                return result.posts || [];
            })
            .then((posts) => {
                return posts.map((curatorItem) => {
                    const result = {
                        accountImage: curatorItem.user_image,
                        createdDate: parseJSON(curatorItem.source_created_at),
                        text: curatorItem.text,
                        image: curatorItem.image,
                        accountName: curatorItem.user_full_name,
                        source: curatorItem.network_name.toLowerCase(),
                        url: curatorItem.url,
                    };

                    if (curatorItem.video) {
                        result.video = curatorItem.video;
                    }

                    return result;
                });
            });

        return promise;
    }
}
